import { ImageElements } from './image-elements.model';
import { DrawStyle } from './drawStyle.model';
import {AreaMap} from './area-map.model';

export class ImageMap extends ImageElements {

  drawStyle: DrawStyle;
  map: AreaMap;

  }
